import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import type { ParametersGetAll } from './useFetchInvoices'

import { useFetchInvoices } from './useFetchInvoices'

export const queryKeys = createQueryKeys('invoices', {
  all: ({
    workspaceId,
    params,
  }: {
    workspaceId: MaybeRef<string>
    params?: MaybeRef<ParametersGetAll>
  }) => ({
    queryKey: [workspaceId, ...(params ? [params] : [])],
  }),
})

const getAll = ({
  params,
  useQueryOptions = {},
}: {
  params?: MaybeRef<ParametersGetAll>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { getAll } = useFetchInvoices()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.all({
      workspaceId: activeWorkspaceId.value as MaybeRef<string>,
      params,
    }),
    queryFn: () => getAll({
      workspaceId: unref(activeWorkspaceId) ?? '',
      params: unref(params),
    }),
    enabled: () => !!unref(activeWorkspaceId),
    ...useQueryOptions,
  })
}

export const useQueryInvoices = {
  getAll,
}
